import { render } from "./card-reader-icon.svg?vue&type=template&id=6ab1a876"
import script from "./card-reader-icon.svg?vue&type=script&lang=js"
export * from "./card-reader-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3480/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__